import { Injectable, signal } from '@angular/core';

export interface IBildirimTercihleri {
  sesAcik: boolean;
  masaustuAcik: boolean;
  tabSayaciAcik: boolean;
  epostaAcik: boolean;
  pushAcik: boolean;
  sessizSaatAcik: boolean;
  sessizBaslangic: string;
  sessizBitis: string;
  olayTercihleri: Record<string, boolean>;
  oncelikKurallari: {
    acil: { ses: boolean; masaustu: boolean; eposta: boolean };
    normal: { ses: boolean; masaustu: boolean; eposta: boolean };
    dusuk: { ses: boolean; masaustu: boolean; eposta: boolean };
  };
}

const STORAGE_KEY = 'fikoyt-bildirim-tercihleri';

const VARSAYILAN: IBildirimTercihleri = {
  sesAcik: true,
  masaustuAcik: true,
  tabSayaciAcik: true,
  epostaAcik: false,
  pushAcik: true,
  sessizSaatAcik: false,
  sessizBaslangic: '22:00',
  sessizBitis: '08:00',
  olayTercihleri: {
    kart_olusturuldu: true,
    kart_guncellendi: true,
    alt_kart_eklendi: true,
    yorum_eklendi: true,
    atandi: true,
    kart_silindi: true,
    bahsedildi: true,
    hatirlatma: true,
  },
  oncelikKurallari: {
    acil:   { ses: true,  masaustu: true,  eposta: true },
    normal: { ses: true,  masaustu: true,  eposta: false },
    dusuk:  { ses: false, masaustu: false, eposta: false },
  },
};

@Injectable({ providedIn: 'root' })
export class BildirimTercihleriService {
  tercihler = signal<IBildirimTercihleri>({ ...VARSAYILAN });

  constructor() { this.yukle(); }

  private yukle() {
    try {
      const kayitli = localStorage.getItem(STORAGE_KEY);
      if (kayitli) {
        const parsed = JSON.parse(kayitli);
        this.tercihler.set({
          ...VARSAYILAN, ...parsed,
          olayTercihleri: { ...VARSAYILAN.olayTercihleri, ...parsed.olayTercihleri },
          oncelikKurallari: {
            acil:   { ...VARSAYILAN.oncelikKurallari.acil,   ...parsed.oncelikKurallari?.acil },
            normal: { ...VARSAYILAN.oncelikKurallari.normal, ...parsed.oncelikKurallari?.normal },
            dusuk:  { ...VARSAYILAN.oncelikKurallari.dusuk,  ...parsed.oncelikKurallari?.dusuk },
          },
        });
      }
    } catch {}
  }

  oncelikKuraliAl(oncelik: 'acil' | 'normal' | 'dusuk'): { ses: boolean; masaustu: boolean; eposta: boolean } {
    return this.tercihler().oncelikKurallari?.[oncelik] ?? VARSAYILAN.oncelikKurallari[oncelik];
  }

  kaydet(tercih: Partial<IBildirimTercihleri>) {
    this.tercihler.update(t => ({ ...t, ...tercih }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this.tercihler()));
  }

  olayTercihKaydet(olay: string, aktif: boolean) {
    this.tercihler.update(t => ({
      ...t,
      olayTercihleri: { ...t.olayTercihleri, [olay]: aktif }
    }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this.tercihler()));
  }

  olayAktifMi(olay: string): boolean {
    return this.tercihler().olayTercihleri?.[olay] !== false;
  }

  sessizSaatteMi(): boolean {
    if (!this.tercihler().sessizSaatAcik) return false;
    const now = new Date();
    const saat = now.getHours() * 60 + now.getMinutes();
    const baslangic = this.saatDakikayaCevir(this.tercihler().sessizBaslangic);
    const bitis = this.saatDakikayaCevir(this.tercihler().sessizBitis);
    if (baslangic > bitis) return saat >= baslangic || saat < bitis;
    return saat >= baslangic && saat < bitis;
  }

  private saatDakikayaCevir(saat: string): number {
    const [s, d] = (saat || '00:00').split(':').map(Number);
    return (s || 0) * 60 + (d || 0);
  }
}
